export default {
  methods: {
    handleError(error) {
      console.error(error);
    },
  },
  computed: {
    apiUrl() {
      return this.$store.state.server_url_clear;
    },
    requestHeaders() {
      return {
        "Content-Type": "application/json",
        Authorization: this.$store.state.auth.token,
      };
    },
  },
};
